import styled from "@emotion/styled";

export const AppContainer = styled.div`
  min-height: calc(100vh - 52px);
`;
